import React, { useState, useEffect } from "react"
import { Card, CardHeader, CardBody } from "reactstrap"
import { FLASH } from "../../helpers/data_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import {
  currencyFormatWithAlert,
  currencyFormatWithoutDecimal,
  numberFormat,
  currencyFormat,
  getPercentageWithAlert
} from "../../helpers/api_helper";

const WeekPerformance = ({ mealPeriod, leftFilter, currency, mealString }) => {
  const [forecastAjax, setForecastAjax] = useState(false);
  const [data, setData] = useState([]);
  // const [data, setData] = useState([
  //   // Static data from the provided HTML
  //   {
  //     lunch: "SEPTEMBER",
  //     revenue: "$112,500",
  //     revBud: "+6%",
  //     revLY: "+24%",
  //     covers: "2250",
  //     coversBud: "-7%",
  //     coversLY: "+29%",
  //     avgChk: "$50",
  //     avgChkBud: "+6%",
  //     avgChkLY: "-$1",
  //     // decreasePrice: "",
  //     // increasePrice: "",
  //     // improveVisibility: "",
  //   },
  //   {
  //     lunch: "TRENDING TO CLOSE (31st October)",
  //     revenue: "$115,000",
  //     revBud: "+8%",
  //     revLY: "+26%",
  //     covers: "2300",
  //     coversBud: "-6%",
  //     coversLY: "+28%",
  //     avgChk: "$51",
  //     avgChkBud: "+8%",
  //     avgChkLY: "+$1",
  //     // decreasePrice: "",
  //     // increasePrice: "",
  //     // improveVisibility: "",
  //   },
  //   {
  //     lunch: "Below or Above Past 3 Months AVG",
  //     revenue: "$109,800",
  //     revBud: "+5%",
  //     revLY: "+22%",
  //     covers: "2200",
  //     coversBud: "-9%",
  //     coversLY: "+27%",
  //     avgChk: "$49",
  //     avgChkBud: "+5%",
  //     avgChkLY: "-$3",
  //     // decreasePrice: "",
  //     // increasePrice: "",
  //     // improveVisibility: "",
  //   },
  //   {
  //     lunch: "Mon",
  //     revenue: "$110,000",
  //     revBud: "+7%",
  //     revLY: "+25%",
  //     covers: "2235",
  //     coversBud: "-8%",
  //     coversLY: "+30%",
  //     avgChk: "$51",
  //     avgChkBud: "+7%",
  //     avgChkLY: "-$2",
  //     decreasePrice: "N",
  //     increasePrice: "Y",
  //     improveVisibility: "N",
  //   },
  //   {
  //     lunch: "Tue",
  //     revenue: "$109,500",
  //     revBud: "+6%",
  //     revLY: "+24%",
  //     covers: "2225",
  //     coversBud: "-7%",
  //     coversLY: "+28%",
  //     avgChk: "$50",
  //     avgChkBud: "+6%",
  //     avgChkLY: "-$2",
  //     decreasePrice: "N",
  //     increasePrice: "Y",
  //     improveVisibility: "N",
  //   },
  //   {
  //     lunch: "Wed",
  //     revenue: "$111,200",
  //     revBud: "+7%",
  //     revLY: "+26%",
  //     covers: "2240",
  //     coversBud: "-7%",
  //     coversLY: "+29%",
  //     avgChk: "$51",
  //     avgChkBud: "+7%",
  //     avgChkLY: "-$1",
  //     decreasePrice: "N",
  //     increasePrice: "N",
  //     improveVisibility: "Y",
  //   },
  //   {
  //     lunch: "Thu",
  //     revenue: "$113,000",
  //     revBud: "+8%",
  //     revLY: "+27%",
  //     covers: "2275",
  //     coversBud: "-6%",
  //     coversLY: "+31%",
  //     avgChk: "$50",
  //     avgChkBud: "+8%",
  //     avgChkLY: "$0",
  //     decreasePrice: "N",
  //     increasePrice: "Y",
  //     improveVisibility: "Y",
  //   },
  //   {
  //     lunch: "Fri",
  //     revenue: "$114,500",
  //     revBud: "+9%",
  //     revLY: "+28%",
  //     covers: "2290",
  //     coversBud: "-5%",
  //     coversLY: "+32%",
  //     avgChk: "$52",
  //     avgChkBud: "+9%",
  //     avgChkLY: "+$1",
  //     decreasePrice: "N",
  //     increasePrice: "Y",
  //     improveVisibility: "N",
  //   },
  //   {
  //     lunch: "Sat",
  //     revenue: "$115,800",
  //     revBud: "+10%",
  //     revLY: "+30%",
  //     covers: "2315",
  //     coversBud: "-4%",
  //     coversLY: "+34%",
  //     avgChk: "$53",
  //     avgChkBud: "+10%",
  //     avgChkLY: "+$2",
  //     decreasePrice: "N",
  //     increasePrice: "N",
  //     improveVisibility: "N",
  //   },
  //   {
  //     lunch: "Sun",
  //     revenue: "$116,200",
  //     revBud: "+11%",
  //     revLY: "+31%",
  //     covers: "2330",
  //     coversBud: "-3%",
  //     coversLY: "+35%",
  //     avgChk: "$54",
  //     avgChkBud: "+11%",
  //     avgChkLY: "+$3",
  //     decreasePrice: "Y",
  //     increasePrice: "N",
  //     improveVisibility: "Y",
  //   },
  // ])

  useEffect(() => {
    const controller = new AbortController();
    setForecastAjax(true);
    postDataAPI({
      serviceName: FLASH.serviceName,
      op: FLASH.op_day_of_week_performance,
      leftFilter: leftFilter,
      mealPeriod: mealPeriod
    }, controller.signal).then((response) => {
      //console.log(response)
      setForecastAjax(false);
      if (response.status === "ok") {
        //console.log(response.data.data);                                           
        setData(response.data.data);
      } else {
        // console.log(response);
      }
    });

    return () => {
        controller.abort();
    };

  }, [mealPeriod, leftFilter]);

  return (
    <Card>
      <CardHeader className="align-items-center">
        <div className="d-flex align-items-start">
          <div className={`icon-box rounded bg-danger text-white`}>
            <i className="ri-calendar-2-fill"></i>
          </div>
          <div className="ps-2">
            <h4 className="card-title mb-1">
              Day of Week Performance
            </h4>
            <p className="text-muted mb-0">
              Weekday revenue patterns with action recommendations.
            </p>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <div className="table-responsive">
          <table
            className="table table-bordered"

          >
            <tbody>
              <tr
                style={{
                  backgroundColor: "#F9F9F9", // Grey for first 4 rows
                  fontWeight: "600",
                  verticalAlign: "middle"
                }}
              >
                <td width="15%">{mealString}</td>
                <td width="5%">REVENUE</td>
                <td width="7%">%vBUD</td>
                <td width="7%">%vLY</td>
                <td width="5%">COVERS</td>
                <td width="7%">%vBUD</td>
                <td width="7%">%vLY</td>
                <td width="5%">AVG CHECK</td>
                <td width="7%">{currency}vBUD</td>
                <td width="7%">{currency}vLY</td>
                <td width="7%"
                  rowSpan="4"
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  DECREASE
                  PRICE
                  <br />
                  (BOOST COVERS)
                </td>

                <td width="7%"
                  rowSpan="4"
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  INCREASE
                  PRICE <br />
                  (YIELD)
                </td>

                <td width="7%"
                  rowSpan="4"
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  IMPROVE
                  VISIBILITY <br />
                  (BOOST COVERS)
                </td>
              </tr>
              {data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  style={{
                    backgroundColor: rowIndex <= 3 ? "#F9F9F9" : "transparent",
                    verticalAlign: "middle"
                  }}
                >
                  {Object.keys(row).map((key, colIndex) => {
                    let cellValue = row[key]

                    // Check if it's the 5th row (index 4) and if it's a column from index 1 to 3
                    const isBlueBg =
                      rowIndex >= 3 && colIndex >= 1 && colIndex <= 3
                    const isOrange =
                      rowIndex >= 3 && colIndex >= 4 && colIndex <= 6
                    const isGreen =
                      rowIndex >= 3 && colIndex >= 7 && colIndex <= 9

                    const ishead = rowIndex <= 3 && colIndex <= 9
                    const isFyCol = colIndex == 0

                    if (colIndex === 2 || colIndex === 5 || colIndex === 3 || colIndex === 6) {
                      cellValue = Number(cellValue).toFixed(2);
                      cellValue = getPercentageWithAlert(cellValue);
                    }
                    if (colIndex === 1 || colIndex === 4) {
                      cellValue = Number(cellValue).toFixed(0);
                    }
                    if (colIndex === 1 || colIndex === 7 || colIndex === 8 || colIndex === 9) {
                      cellValue = currencyFormatWithAlert(cellValue, currency)
                    }

                    if (colIndex === 10) {
                      cellValue = (Number(row['covers_bud']) < 0 && Number(row['avgchk_bud']) > 0) ? "Y" : "N";
                    }
                    if (colIndex === 11) {
                      cellValue = (Number(row['covers_bud']) > 0 && Number(row['avgchk_bud']) < 0) ? "Y" : "N";
                    }
                    if (colIndex === 12) {
                      cellValue = (Number(row['covers_bud']) < 0 && Number(row['avgchk_bud']) < 0) ? "Y" : "N";
                    }
                    const isGreenCell = cellValue === "Y"
                    const isGreyCell = cellValue === "N"

                    return (
                      <td
                        key={colIndex}
                        style={{
                          backgroundColor: isBlueBg
                            ? "#E5F4FF"
                            : isOrange
                              ? "#FFE5E5"
                              : isGreen
                                ? "#D0F0C0"
                                : ishead
                                  ? "b9b6b4"
                                  : isFyCol
                                    ? "#F9F9F9"
                                    : isGreenCell
                                      ? "#76d770"
                                      : isGreyCell
                                        ? "#c8c4c0"
                                        : "transparent",
                          textAlign:
                            colIndex === 0 && rowIndex < 3 ? "left" : "center",
                          fontWeight: colIndex === 0 ? "600" : "normal",
                        }}
                      >
                        {cellValue}
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  )
}

export default WeekPerformance
